<template>
  <img class="gia-photo" :src="siteSettings.images.giaPhoto" alt="gia" />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useResultsStore } from '@/storePinia/stores/results';

const resultsStore = useResultsStore();
const siteSettings = computed(() => resultsStore.siteSettings);
</script>

<style lang="scss" scoped>
.gia-photo {
  display: block;
  max-width: 42px;
}
</style>
